export default __webpack_public_path__ + "static/media/not-auth-background.93ed48e3.png";